/* eslint-disable @next/next/no-img-element */
import roundToTwoSignificantDecimals from "@/common/function/roundToTwoSignificantDecimals";
import { GeneralPropsType } from "@/common/types";
import { useGlobalData } from "@/contexts/GlobalData";
import { useRealtimeData } from "@/contexts/RealtimeData";
import { Modal, ModalContent, useDisclosure } from "@nextui-org/react";
import clsx from "clsx";
import Link from "next/link";
import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import QRCode from "react-qr-code";
import CopyTextComponent from "../CopyTextComponent";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeFrame from "../DynamicSizeFrame";
import DynamicSizeIcon from "../DynamicSizeIcon";
import HorizontalScroll from "../HorizontalScroll";
import Input from "../Input";
import LeftGradientBorder from "../LeftGradientBorder";
import ModalLayout from "../ModalLayout";
import NetworkOption from "../NetworkOption";
import PaymentOption from "../PaymentOption";
import PrimaryButton from "../PrimaryButton";
import SecondaryButton from "../SecondaryButton";
import SettingItem from "../SettingItem";
import Share from "../Share";
import TokenNotFound from "../TokenNotFound";
import TokenWithdrawOption, { Token } from "../TokenWithdrawOption";
import styles from "./index.module.css";
import openLink from "@/utils/openLink";
import { generateToBase64, reverseBase64 } from "@/utils/generateToBase64";
import SubPaymentFeeInfo from "../SubPaymentFeeInfo";
import { cn } from "@/lib/utils";
import getSubPaymentFeeService from "@/services/getSubPaymentFeeService";
import FiatDepositInput from "../FiatDepositInput";
import { PAYMENT_TYPE, space } from "@/common/const";
import { ActionType } from "@/types/action";
interface DepositFunctionPropsType extends GeneralPropsType {
  onFinishStep1?: (data?: any) => any;
  onFinishStep2?: (data?: any) => any;
  onFinish?: (data?: any) => any;
  showOptions?: boolean;
  handlePresale?: (successCallback: (data: any) => void, errorCallback: () => void) => void;
  bypass?: boolean;
}
export enum DepositMethod {
  SUB_PAYMENT = "sub_payment",
  TBK_INTERNAL = "tbk_internal",
  ON_CHAIN = "on_chain",
}
const DepositFunction = forwardRef<HTMLDivElement, DepositFunctionPropsType>(({
  children,
  className,
  onClick,
  onFinish,
  onFinishStep1,
  onFinishStep2,
  showOptions,
  handlePresale,
  bypass
}, ref) => {
  const {
    isOpen: isOpenQR,
    onOpen: onOpenQR1,
    onOpenChange: onOpenChangeQR,
    onClose: onCloseQR
  } = useDisclosure();
  const {
    isOpen: isOpenNetwork,
    onOpen: onOpenNetwork,
    onOpenChange: onOpenChangeNetwork,
    onClose: onCloseNetwork
  } = useDisclosure();
  const onOpenQR = () => {
    onOpenNetwork();
  };
  const {
    isOpen: isOpenTokens,
    onOpen: onOpenTokens,
    onOpenChange: onOpenChangeTokens,
    onClose: onCloseTokens
  } = useDisclosure();
  const handleShowReceiveQR = () => {
    setDepositMethod(DepositMethod.TBK_INTERNAL);
    onOpenQR1();
  };
  const {
    isOpen: isOpenOptions,
    onOpen: onOpenOptions,
    onOpenChange: onOpenChangeOptions,
    onClose: onCloseOptions
  } = useDisclosure();
  const {
    isOpen: isPaymentOptions,
    onOpen: onOpenPaymentOptions,
    onOpenChange: onOpenChangePaymentOptions,
    onClose: onClosePaymentOptions
  } = useDisclosure();
  const {
    isOpen: isOpenFiat,
    onOpen: onOpenFiat,
    onClose: onCloseFiat
  } = useDisclosure();
  const {
    translate,
    getIcon,
    userWallets,
    userInfo,
    runEffectNavigation,
    subPaymentFeeData,
    setSubPaymentFeeData
  } = useGlobalData();
  const [selectedMethod, setSelectedMethod] = useState<PAYMENT_TYPE>(PAYMENT_TYPE.WALLET_TBK);
  const [selectedToken, setSelectedToken] = useState<any>();
  const [selectedNetwork, setSelectedNetWork] = useState<any>();
  const [tokenSearchedList, setTokenSearchedList] = useState<any[]>();
  const {
    tokensRateState
  } = useRealtimeData();
  const prefix = "deposit_f_";
  const tokens = useMemo(() => userWallets?.tokenDeposit?.filter((e: any) => !e.main), [userWallets]);
  const [depositMethod, setDepositMethod] = useState<DepositMethod>(DepositMethod.ON_CHAIN);
  useEffect(() => {
    !selectedToken && setSelectedToken(tokens?.[0]);
  }, [tokens]);
  const handleSelectToken = (token?: Token) => {
    setSelectedToken(token);
  };
  const networks = selectedToken?.networks;
  useEffect(() => {
    setSelectedNetWork(networks?.[0]);
  }, [networks]);
  const handleCloseDeposit = () => {
    setTokenSearchedList(undefined);
  };
  return <div ref={ref} className={clsx("", styles.container, className)}>
                <span onClick={() => {
      if (showOptions) {
        return onOpenOptions();
      }
      onOpenPaymentOptions();
      // if (!userInfo?.permissions?.sub_payment_gw) {
      //     return onOpenTokens();
      // }
      onClick?.();
    }}>
                    {children}
                </span>
                <Modal isOpen={isOpenTokens} placement="bottom" onOpenChange={onOpenChangeTokens} isDismissable={false} hideCloseButton backdrop="blur">
                    <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]">
                        <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwd" title={translate(prefix + "Select a coin to continue")} onClose={() => {
          onCloseTokens();
          onFinishStep1?.();
          handleCloseDeposit();
        }}>
                            <div className="flex flex-col justify-center gap-4">
                                {/* <Input
                                    showSearchIcon
                                    className="w-full"
                                    onChange={(e: any) => {
                                        const tokensSearched = tokens?.filter(
                                            (token: any) =>
                                                !e?.target?.value ||
                                                token?.symbol
                                                    ?.toLowerCase()
                                                    ?.trim()
                                                    ?.startsWith(e?.target?.value?.toLowerCase()?.trim())
                                        );
                                        setTokenSearchedList(tokensSearched);
                                    }}
                                    placeholder={translate(prefix + "Search token")}
                                    isShowMaxButton={false}
                                 /> */}
                                {(tokenSearchedList ?? tokens)?.length > 0 && <>
                                        {/* <DynamicFontSize
                                            fontSize={16}
                                            className="text-white leading-[150%] font-medium"
                                         >
                                            {translate(prefix + "Select a coin to continue")}
                                         </DynamicFontSize> */}
                                        <div className="flex flex-col gap-2 w-full">
                                            {(tokenSearchedList ?? tokens)?.map?.((token: any) => {
                  return <TokenWithdrawOption onClick={() => handleSelectToken(token)} key={token?.symbol} className="" token={{
                    name: token?.symbol,
                    icon: token?.logo?.url || token?.logo,
                    balance: token?.balance,
                    balanceCurrency: !token?.balance ? 0 : +token?.balance * (tokensRateState?.[token?.symbol || ""]?.USD ?? 0),
                    active: selectedToken?.slug == token?.slug
                  }} />;
                })}
                                        </div>
                                    </>}
                                {(tokenSearchedList ?? tokens)?.length <= 0 && <TokenNotFound className="my-6" contentKey={prefix + "_not_found_"} />}
                                <PrimaryButton status={!selectedToken ? "disabled" : "normal"} onClick={() => {
              if (selectedMethod == PAYMENT_TYPE.WALLET_TBK) {
                onOpenQR();
              } else {
                onOpenFiat();
                onCloseTokens();
              }
            }} statusKey={prefix + "continue"}></PrimaryButton>
                            </div>
                        </ModalLayout>
                    </ModalContent>
                </Modal>
                <Modal isOpen={isOpenNetwork} placement="bottom" onOpenChange={onOpenChangeNetwork} isDismissable={false} hideCloseButton backdrop="blur">
                    <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]">
                        <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwd" title={translate(prefix + "selected network")} onClose={() => {
          onCloseNetwork();
          onFinishStep2?.();
          handleCloseDeposit();
        }}>
                            <div className="flex flex-col gap-2 w-full">
                                {networks?.map?.((e: any) => <NetworkOption className="cursor-pointer w-full" onClick={() => setSelectedNetWork(e)} key={e.id} icon={e?.image?.url} name={e.network_name} isSelected={e.id == selectedNetwork?.id} />)}
                            </div>
                            <PrimaryButton className="w-full mt-4" status={!selectedNetwork ? "disabled" : "normal"} onClick={() => onOpenQR1()} statusKey={prefix + "continue"}></PrimaryButton>
                        </ModalLayout>
                    </ModalContent>
                </Modal>
                <Modal isOpen={isOpenOptions} placement="bottom" onOpenChange={onOpenChangeOptions} isDismissable={false} hideCloseButton backdrop="blur">
                    <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]">
                        <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwdfhf" title={translate(prefix + "options")} onClose={() => {
          onCloseOptions();
        }}>
                            <div className="flex flex-col justify-center gap-3">
                                <LeftGradientBorder onClick={() => {
              onOpenTokens();
              const tm = setTimeout(() => {
                onCloseOptions();
                clearTimeout(tm);
              }, 1000);
            }} className="p-3 rounded-2xl " background="right_to_left">
                                    <SettingItem className="w-full" name={translate(prefix + "deposit")} icon={getIcon(prefix + "deposit option")} des={translate(prefix + "deposit description")} />
                                </LeftGradientBorder>
                                <Link href="/convert">
                                    <LeftGradientBorder className="p-3 rounded-2xl" background="right_to_left">
                                        <SettingItem name={translate(prefix + "convert")} icon={getIcon(prefix + "convert option")} des={translate(prefix + "convert description")} />
                                    </LeftGradientBorder>
                                </Link>
                            </div>
                            <DynamicFontSize fontSize={10} className="text-description leading-[140%] font-light italic mt-4">
                                {translate(prefix + "add funds description")}
                            </DynamicFontSize>
                        </ModalLayout>
                    </ModalContent>
                </Modal>

                <Modal isOpen={isOpenQR} placement="bottom" onOpenChange={onOpenChangeQR} isDismissable={false} hideCloseButton backdrop="blur">
                    <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]">
                        <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c5467015d0edd" title={<div className="flex items-center gap-2">
                                    <DynamicSizeIcon icon={selectedToken?.logo?.url ?? selectedToken?.logo} width={20}></DynamicSizeIcon>
                                    <span>{translate(prefix + "withdraw")}</span> <span>{selectedToken?.symbol}</span>
                                </div>} onClose={() => {
          onCloseQR();
          setDepositMethod(DepositMethod.ON_CHAIN);
          onCloseNetwork();
          onCloseTokens();
          onFinish?.();
          handleCloseDeposit();
        }}>
                            <div className="flex flex-col items-center justify-center gap-4">
                                <div className="!max-w-[100%] bg-[#222] rounded-lg p-6 w-full" id="share-component">
                                    <div className="flex flex-col gap-3 items-center !text-white !max-w-[90%] mx-auto !font-primary">
                                        <div className="flex flex-col items-center">
                                            <DynamicFontSize fontSize={12} className="text-center font-bold leading-[100%] !font-primary !whitespace-nowrap">
                                                {userInfo?.nick_name}
                                            </DynamicFontSize>
                                            <DynamicFontSize fontSize={12} className="text-center !font-primary !whitespace-nowrap">
                                                {userInfo?.username}
                                            </DynamicFontSize>
                                        </div>
                                        <div className={clsx("p-3 bg-white rounded-2xl relative !max-w-[70%]")}>
                                            <QRCode size={256} style={{
                    height: "auto",
                    width: "100%"
                  }} value={depositMethod == DepositMethod.ON_CHAIN ? selectedNetwork?.linkQr ?? "" : `${ActionType.TRANSFER}${space}${userInfo?.username}`} viewBox={`0 0 256 256`}
                  // level="H"
                  />
                                            {/* <CanvasAsImage
                                                src={selectedToken?.logo?.url ?? selectedToken?.logo}
                                                className="!absolute inset-0 !w-[16%] aspect-square border-2 border-red-500 m-auto z-[9999]"
                                             /> */}
                                            {depositMethod == DepositMethod.ON_CHAIN && <DynamicSizeIcon width={20} icon={selectedToken?.logo?.url ?? selectedToken?.logo} className="!absolute inset-0 !w-[16%] aspect-square m-auto" />}
                                            {/* <DynamicSizeFrame
                                                className={clsx(
                                                    "!absolute inset-0 !w-[16%] aspect-square m-auto",
                                                    styles.token_icon
                                                )}
                                                width={28}
                                                ref={tokenLogoRef}
                                             ></DynamicSizeFrame> */}
                                        </div>

                                        {depositMethod == DepositMethod.ON_CHAIN && <>
                                                <div className="flex flex-col items-start self-start">
                                                    <DynamicFontSize fontSize={10} className="font-normal leading-[100%] text-description !whitespace-nowrap !font-primary">
                                                        {translate(prefix + "selected network")}
                                                    </DynamicFontSize>
                                                    <button className="flex items-center gap-1 group" onClick={() => {
                      onCloseQR();
                      setDepositMethod(DepositMethod.ON_CHAIN);
                      setTimeout(() => {
                        onOpenNetwork();
                      }, 200);
                    }}>
                                                        <DynamicFontSize fontSize={13} className="font-medium !font-primary ">
                                                            {selectedNetwork?.network_name}
                                                        </DynamicFontSize>
                                                        <DynamicSizeIcon width={10} icon={getIcon("arrow_right")} className="group-active:translate-x-3 group-focus:translate-x-3 duration-250" />
                                                    </button>
                                                </div>
                                                <div className="flex flex-col items-start self-start w-full">
                                                    <DynamicFontSize fontSize={10} className="font-normal leading-[100%] text-description !whitespace-nowrap !font-primary">
                                                        {translate(prefix + "selected address")}
                                                    </DynamicFontSize>
                                                    <DynamicFontSize fontSize={13} className="font-medium w-full">
                                                        <CopyTextComponent value={selectedNetwork?.address} className="w-full">
                                                            <DynamicFontSize fontSize={13} className="leading-[150%] break-words w-full !max-w-full text-left !font-primary">
                                                                {selectedNetwork?.address}
                                                            </DynamicFontSize>
                                                        </CopyTextComponent>
                                                    </DynamicFontSize>
                                                </div>
                                            </>}
                                        <div className="flex items-center gap-1 p-3 bg-[#464646] rounded-2xl">
                                            <DynamicSizeFrame width={16} height={16}>
                                                <svg className="w-full" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <mask id="mask0_13468_22007" style={{
                        maskType: "alpha"
                      }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                                        <rect width="20" height="20" fill="#D9D9D9" />
                                                    </mask>
                                                    <g mask="url(#mask0_13468_22007)">
                                                        <path d="M9.99571 13.7756C10.1615 13.7756 10.302 13.7195 10.4172 13.6073C10.5323 13.495 10.5899 13.356 10.5899 13.1902C10.5899 13.0243 10.5338 12.8838 10.4215 12.7687C10.3093 12.6537 10.1703 12.5962 10.0045 12.5962C9.83862 12.5962 9.69814 12.6523 9.583 12.7643C9.46786 12.8766 9.41029 13.0156 9.41029 13.1814C9.41029 13.3473 9.4664 13.4877 9.57862 13.6029C9.69085 13.718 9.82987 13.7756 9.99571 13.7756ZM9.45842 11.0641H10.5417V6.06413H9.45842V11.0641ZM10.0072 17.5833C8.96397 17.5833 7.98147 17.3859 7.05966 16.9912C6.13786 16.5965 5.33105 16.0534 4.63925 15.3618C3.94744 14.6703 3.40404 13.8641 3.00904 12.9433C2.61418 12.0226 2.41675 11.0388 2.41675 9.99183C2.41675 8.94489 2.61411 7.96399 3.00883 7.04913C3.40355 6.13426 3.94668 5.33093 4.63821 4.63913C5.32973 3.94732 6.13592 3.40392 7.05675 3.00892C7.97744 2.61406 8.96126 2.41663 10.0082 2.41663C11.0552 2.41663 12.0361 2.61399 12.9509 3.00871C13.8658 3.40343 14.6691 3.94656 15.3609 4.63808C16.0527 5.32961 16.5961 6.13413 16.9911 7.05163C17.386 7.96926 17.5834 8.94968 17.5834 9.99288C17.5834 11.0361 17.3861 12.0186 16.9913 12.9404C16.5966 13.8622 16.0535 14.669 15.362 15.3608C14.6704 16.0526 13.8659 16.596 12.9484 16.991C12.0308 17.3859 11.0504 17.5833 10.0072 17.5833ZM10.0001 16.5C11.8056 16.5 13.3404 15.868 14.6042 14.6041C15.8681 13.3402 16.5001 11.8055 16.5001 9.99996C16.5001 8.1944 15.8681 6.65968 14.6042 5.39579C13.3404 4.1319 11.8056 3.49996 10.0001 3.49996C8.19453 3.49996 6.6598 4.1319 5.39591 5.39579C4.13203 6.65968 3.50008 8.1944 3.50008 9.99996C3.50008 11.8055 4.13203 13.3402 5.39591 14.6041C6.6598 15.868 8.19453 16.5 10.0001 16.5Z" fill="#FFAD40" />
                                                    </g>
                                                </svg>
                                            </DynamicSizeFrame>

                                            {depositMethod == DepositMethod.ON_CHAIN && <DynamicFontSize fontSize={12} className="text-white !font-primary">
                                                    {translate(prefix + "before deposit")}
                                                    <span className="!font-primary not_apply_adjust_color_tbk font-bold">
                                                        {roundToTwoSignificantDecimals(selectedNetwork?.min_balance_deposit)}
                                                        &nbsp;
                                                        {selectedToken?.symbol}
                                                    </span>
                                                    {translate(prefix + "after deposit")}
                                                </DynamicFontSize>}
                                            {depositMethod == DepositMethod.TBK_INTERNAL && <DynamicFontSize fontSize={12} className="text-white !font-primary">
                                                    {translate(prefix + "before deposit internal")}
                                                </DynamicFontSize>}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 justify-center w-full">
                                    <CopyTextComponent value={selectedNetwork?.address}>
                                        <SecondaryButton className="!text-secondary !px-3 !py-0.5 flex items-center gap-1.5 !h-fit">
                                            {translate(prefix + "Scan QR Code")}
                                            <DynamicSizeIcon width={20} icon={getIcon("copy_icon_v3")} className="text-secondary leading-[120%]" />
                                        </SecondaryButton>
                                    </CopyTextComponent>
                                    <Share elementId="share-component" backgroundColor="#222"
              // message={translate("This is my deposit card")}
              message={selectedNetwork?.address} shareTitle={translate("Deposit information")}>
                                        <SecondaryButton className="!text-secondary !px-3 !py-1 flex items-center gap-1.5 !h-fit">
                                            {translate(prefix + "share code")}
                                            <DynamicSizeIcon width={20} icon={getIcon("share_qr")} className="text-secondary leading-[120%]" />
                                        </SecondaryButton>
                                    </Share>
                                </div>
                            </div>
                        </ModalLayout>
                    </ModalContent>
                </Modal>

                {/* Payment Options */}
                <Modal isOpen={isPaymentOptions} placement="bottom" onOpenChange={onOpenChangePaymentOptions} isDismissable={false} hideCloseButton backdrop="blur">
                    <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]">
                        <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwd" title={translate(prefix + "withdraw")} onClose={() => {
          onClosePaymentOptions();
          onFinishStep1?.();
          handleCloseDeposit();
        }}>
                            <div className="flex flex-col justify-center gap-4">
                                <SettingItem onClick={handleShowReceiveQR} icon={getIcon("from_tbk_internal")} name={translate(prefix + "deposit with tbk internal title")} des={translate(prefix + "deposit with tbk internal desc")}>
                                    <DynamicFontSize fontSize={11} className={cn("rounded-md bonus_bg leading-[100%] w-fit px-1 py-0.5 mt-1")}>
                                        <span className={"bonus_text"}>{translate(prefix + "recommended")}</span>
                                    </DynamicFontSize>
                                </SettingItem>
                                <div className="divider" />
                                <SettingItem onClick={() => {
              onOpenTokens();
              setSelectedMethod(PAYMENT_TYPE.WALLET_TBK);
            }} icon={getIcon("from_tbk")} name={translate(prefix + "deposit with tbk title")} des={translate(prefix + "deposit with tbk desc")}>
                                    {/* <DynamicFontSize
                                        fontSize={11}
                                        className={cn("rounded-md bonus_bg leading-[100%] w-fit px-1 py-0.5 mt-1")}
                                     >
                                        <span className={"bonus_text"}>{translate(prefix + "recommended")}</span>
                                     </DynamicFontSize> */}
                                </SettingItem>
                                {userInfo?.permissions?.sub_payment_gw && <>
                                        <div className="divider" />

                                        <FiatDepositInput isOpen={isOpenFiat} onClose={onCloseFiat} onOpen={onOpenFiat} classNameChildren="w-full" prefixFromParent={prefix} handleOpenTokens={onOpenTokens} selectedToken={selectedToken} onClosePaymentOptions={onClosePaymentOptions} switchToDepositTBKWallet={() => {
                setSelectedMethod(PAYMENT_TYPE.WALLET_TBK);
                onOpenQR1();
              }}>
                                            <SettingItem onClick={() => {
                  setSelectedMethod(PAYMENT_TYPE.SUB_PAYMENT);
                }} className="w-full"
                // onClick={handleNavigate}
                icon={getIcon("from_bank")} name={translate(prefix + "deposit sub payment title")} des={translate(prefix + "deposit sub payment desc")}>
                                                <SubPaymentFeeInfo className="mt-1"
                  // onContinue={handleNavigate}
                  ></SubPaymentFeeInfo>
                                            </SettingItem>
                                        </FiatDepositInput>
                                    </>}
                            </div>
                        </ModalLayout>
                    </ModalContent>
                </Modal>
            </div>;
});
DepositFunction.displayName = "DepositFunction";
export default DepositFunction;